import { useNavigate, useLocation, NavigateFunction, Location } from 'react-router-dom';

import { LocationState } from '../interfaces';
import { RedirectOptions, UseRedirect } from '../interfaces/hooks';

export const useRedirect: () => UseRedirect = (): UseRedirect => {
  const navigate: NavigateFunction = useNavigate();
  const location: Location = useLocation();

  const redirect: (targetRoute: string, options?: RedirectOptions) => void = (
    targetRoute: string, options: RedirectOptions = {}
  ): void => {
    const { isExternal = false, inNewTab = false, withReplaceState = false }: RedirectOptions = options;

    if (targetRoute !== location.pathname) {
      if (isExternal && !inNewTab) {
        window.location.assign(targetRoute);
      } else if (inNewTab) {
        window.open(targetRoute, '_blank')?.focus();
      } else {
        navigate(targetRoute, { state: { from: location } as LocationState, replace: withReplaceState });
      }
    }
  };

  return { redirect };
};
